import React from "react";
import Icon from "@mdi/react";
import { mdiStethoscope, mdiLock } from "@mdi/js";

import PlayerInjuryItem from "../../Player/PlayerInjuryItem";
import { SubscriptionContext } from "../../../services/SubscriptionService";
import styles from "./styles.scss";
import { Button } from "../../Button";
import { useFreeTrialClaimed } from "src/services/UserService";
// import { Team } from "src/common-services";

const TeamPlayerInjuries = ({ game, team, hasAccess }: { game: any; team: any; hasAccess: boolean }) => {
  const trialClaimed = useFreeTrialClaimed();
  const { injuredPlayers: injuries } = team;
  if (!hasAccess) {
    return (
      <SubscriptionContext.Consumer>
        {({ redirectToPricing }) => (
          <div className="rotoql-player__upgrade-con">
            <div className="rotoql-player__text-container">
              <Icon path={mdiStethoscope} size="35px" color="#515151" />
              <div className="rotoql-player__upgrade-text">
                Get access to Real-Time Offensive and Defensive Injuries with a BetQL Subscription
              </div>
            </div>
            <Button
              onClick={() =>
                redirectToPricing(
                  {
                    screen: "GameView",
                    page: "Game Detail",
                    sport: game.league.name,
                    source: "Player Injuries",
                    awayTeam: game.awayTeam.fullName,
                    homeTeam: game.homeTeam.fullName,
                    gameId: game.id,
                  },
                  "Game Detail Player Injuries"
                )
              }
              className="rotoql-player__upgrade-btn"
            >
              <Icon className="rotoql-player__upgrade-btn-icon" path={mdiLock} size="16px" color="#fff" />
              <span>{trialClaimed ? "Upgrade now" : "Start Free Trial"}</span>
            </Button>
            <style jsx global>
              {styles}
            </style>
          </div>
        )}
      </SubscriptionContext.Consumer>
    );
  }

  if (!injuries || injuries.length === 0) {
    return (
      <div className="rotoql-player__no-injury-con">
        <Icon path={mdiStethoscope} size="35px" color="#515151" />
        <div className="rotoql-player__no-injury-text">No Injured Players</div>
        <style jsx global>
          {styles}
        </style>
      </div>
    );
  }

  return injuries.map((injuredPlayer: any, index: number) => {
    return (
      <div className="rotoql-player__item" key={index}>
        <PlayerInjuryItem team={team} injuredPlayer={injuredPlayer} />
        <style jsx global>
          {styles}
        </style>
      </div>
    );
  });
};

export default TeamPlayerInjuries;
